// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"6fe1069e","189":"6fe1069e","649":"6fe1069e","693":"6fe1069e"}[chunkId] + ".chunk.css";
};